import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;


const NewsLetterService = {
  create: async (data) => {
    const response = await apiService.post("/newsletteremails", data);
    return response.data;
  },
};

export default NewsLetterService;
